import { type Currency } from '@webapp/core/entities/external/Currency'
import {
  MileageRatePresetUnits,
  UnitsOfDistance,
} from '@webapp/modules/expense/entities/enums'
import { MileageRatePreset } from '@webapp/modules/expense/entities/MileageRatePreset'

interface BuildMileageRatePresetParams {
  id: Nullable<number>
  name: Nullable<string>
  rate: number
  unitOfDistance: 'km' | 'mi'
  advisoryFuelRate?: number
  currency: Currency
}

export const buildMileageRatePreset = ({
  id,
  name,
  rate,
  unitOfDistance,
  advisoryFuelRate,
  currency,
}: BuildMileageRatePresetParams): Nullable<MileageRatePreset> => {
  if (!id || !name || !rate) return null
  return new MileageRatePreset({
    id,
    name,
    rate,
    currency,
    unit:
      unitOfDistance === UnitsOfDistance.MILES
        ? MileageRatePresetUnits.MILES
        : MileageRatePresetUnits.KILOMETERS,
    advisoryFuelRate: advisoryFuelRate ?? null,
    tax: null,
  })
}
